import moment from 'moment';

import {
  ORDER_CHANGE_ACTIVE_TAB,
  ORDER_CHANGE_TABLE_OPTION,
  ORDER_CHANGE_TABLE_OPTIONS,
  ORDER_CHANGE_VALUE,
  ORDER_CHANGE_VALUES,
  ORDER_CHECKOUT_COMPLETE,
} from '@shared/store/constants/mutationTypes';
import apiClient from '@shared/lib/general/apiClient';
import initialState from './orderInitialState';
import makeQuery from './utils/makeQuery';

const actions = {
  changeOrderValue({ commit }, payload) {
    const {
      field,
      value,
    } = payload;
    commit({
      type: ORDER_CHANGE_VALUE,
      field,
      value,
    });
  },
  async changeNewOrderValue({ commit, state }, payload) {
    const {
      field,
      value,
      filterInfo,
    } = payload;

    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'processingOrder',
      value: true,
    });

    let filterFlag;

    const oldOrder = structuredClone(state.newOrder);
    if (field === 'customer') {
      oldOrder.customerId = value.customerId;
      oldOrder.customerName = `${value.firstName} ${value.lastName}`;
      oldOrder.customer = value;
      oldOrder.chargeMember = true;
    }
    if (field === 'campaignCode') {
      oldOrder.campaignCode = value;
    }
    if (field === 'shippingTotal') {
      oldOrder.shippingTotal = value;
    }
    if (field === 'product') {
      if (!oldOrder.orderItems) {
        oldOrder.orderItems = [{
          productId: value.id,
          productName: value.itemName,
          price: value.price,
          quantity: 1,
          basePrice: value.price,
          productType: value.type,
          productSku: value.sku,
          productClass: value.itemClass,
          stripePriceId: value.stripePriceId,
          filterHeight: value.filterHeight,
          filterWidth: value.filterWidth,
          filterCatalogId: value.filterCatalogId,
          brand: value.brand,
          thickness: value.thickness,
          merv: value.merv,
          vendor: value.vendor,
          vendorSku: value.vendorSku,
        }];
      } else {
        // DO NOT ALLOW DUPLICATES PRODUCTS
        const productExist = oldOrder.orderItems.find((o) => o.productId === value.id);
        if (!productExist) {
          oldOrder.orderItems.push({
            productId: value.id,
            productName: value.itemName,
            price: value.price,
            quantity: 1,
            basePrice: value.price,
            productType: value.type,
            productSku: value.sku,
            productClass: value.itemClass,
            stripePriceId: value.stripePriceId,
            filterHeight: value.filterHeight,
            filterWidth: value.filterWidth,
            brand: value.brand,
            thickness: value.thickness,
            merv: value.merv,
            vendor: value.vendor,
            vendorSku: value.vendorSku,
          });
        }
      }
    }
    if (field === 'sub') {
      oldOrder.orderItems.forEach((oi) => {
        if (oi.productId === value) {
          if (oi.quantity >= 2) {
            oi.quantity -= 1;
          }
        }
      });
    }
    if (field === 'add') {
      oldOrder.orderItems.forEach((oi) => {
        if (oi.productId === value) {
          oi.quantity += 1;
        }
      });
    }
    if (field === 'remove') {
      const updatedItems = oldOrder.orderItems.filter((oi) => oi.productId !== value);
      oldOrder.orderItems = structuredClone(updatedItems);
    }
    if (field === 'height' || field === 'width' || field === 'thickness') {
      oldOrder.orderItems.forEach((oi) => {
        if (oi.productId === value) {
          if (field === 'height') {
            oi.filterHeight = filterInfo;
          }
          if (field === 'width') {
            oi.filterWidth = filterInfo;
          }
          if (field === 'thickness') {
            oi.filterThickness = filterInfo;
          }
        }
      });
    }

    if (oldOrder.orderItems && (field !== 'height' || field !== 'width')) {
      oldOrder.orderItems.forEach((oi) => {
        if (oi.productType === 'Filter' && oi.productClass === 'Product' && oldOrder.customerId) {
          filterFlag = true;
          oi.showFilter = true;
        }
      });
    }

    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'newOrder',
      value: oldOrder,
    });

    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'processingOrder',
      value: false,
    });
  },
  changeOrderValues({ commit }, payload) {
    commit({
      type: ORDER_CHANGE_VALUES,
      changes: payload,
    });
  },
  changeOrderTableOption({ commit }, payload) {
    const {
      field,
      value,
    } = payload;

    commit({
      type: ORDER_CHANGE_TABLE_OPTION,
      field,
      value,
    });
  },
  changeOrderTableOptions({ commit }, payload) {
    commit({
      type: ORDER_CHANGE_TABLE_OPTIONS,
      changes: payload,
    });
  },
  changeOrderActiveTab({ commit }, payload) {
    const {
      tab,
    } = payload;
    commit({
      type: ORDER_CHANGE_ACTIVE_TAB,
      tab,
    });
  },
  async getAllProductLine({ dispatch }) {
    const { data: all } = await apiClient({
      method: 'GET',
      url: '/products/all',
    });
    dispatch('changeOrderValue', {
      field: 'allProducts',
      value: all,
    });
  },
  async getAllDiscountCodes({ dispatch }) {
    const { data: all } = await apiClient({
      method: 'GET',
      url: '/products/discounts/all',
    });
    dispatch('changeOrderValue', {
      field: 'allDiscountCodes',
      value: all,
    });
  },
  async getMemberAddressList({ commit, state }, customerId) {
    const { newOrder } = state;
    const requestList = [];
    requestList.push(apiClient({
      method: 'GET',
      url: `/addresses/Billing/customers/${customerId}`,
    }));
    requestList.push(apiClient({
      method: 'GET',
      url: `/addresses/Shipping/customers/${customerId}`,
    }));
    const [billingList, shippingList] = await Promise.all(requestList);

    let billingAddress;
    let shippingAddress;
    if (billingList.data.length) {
      [billingAddress] = billingList.data;
    }
    if (shippingList.data.length) {
      [shippingAddress] = shippingList.data;
    }

    const updatedOrder = { ...newOrder, shippingAddress, billingAddress };
    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'newOrder',
      value: updatedOrder,
    });
  },
  async clearOrderFilters({ commit, state, dispatch }, payload) {
    try {
      const {
        copyOrderFilters,
        smacOrderFilters,
      } = state;

      const {
        key,
        showAllOrder,
      } = payload;

      let updatedFilters = {};
      updatedFilters = structuredClone(copyOrderFilters);
      const initialFilter = initialState().smacOrderFilters.find((option) => option.key === key);

      if (initialFilter) {
        updatedFilters = smacOrderFilters.map((option) => {
          if (option.key === key) {
            return initialFilter;
          }
          return option;
        });
      }

      // Make default filter active if no active filter found other than branch
      const activeFound = updatedFilters.find((f) => f.active);
      if (!activeFound) {
        updatedFilters = structuredClone(updatedFilters).map((option) => {
          if (option.key === 'urgent') {
            option.active = true;
          }
          return option;
        });
      }

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'smacOrderFilters',
        value: updatedFilters,
      });

      dispatch('filterOrdersCustomer', {
        filters: updatedFilters,
        showAllOrder,
      });

      dispatch('filterOrdersPartner', {
        filters: updatedFilters,
        showAllOrder,
      });
    } catch (err) {
      console.error('Failed to apply filters', err);
    }
  },
  async filterMemberOrdersCustomer({ commit, state, rootState }) {
    try {
      const {
        orderFilters,
      } = state;

      const {
        admin: {
          adminFilter: {
            corpId,
          },
        },
      } = rootState;

      const queryOrderFilter = makeQuery(orderFilters, corpId);

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'loading',
        value: true,
      });

      const { data: cOrders } = await apiClient({
        method: 'POST',
        url: 'customer/orders/query',
        data: queryOrderFilter,
      });

      commit({
        type: ORDER_CHANGE_VALUES,
        changes: [{
          field: 'customerOrders',
          value: cOrders,
        }, {
          field: 'loading',
          value: false,
        }],
      });
    } catch (err) {
      const {
        orderFilters,
      } = initialState();

      // Apply previous filters
      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'orderFilters',
        value: orderFilters,
      });
      console.error('Failed to apply filters', err);
    }
  },
  async filterOrdersCustomer({ commit, state, rootState }, payload) {
    try {
      const {
        smacOrderFilters,
        isOpen,
      } = state;

      const {
        admin: {
          adminFilter: {
            corpId,
          },
        },
      } = rootState;

      const {
        filters,
        showAllOrder,
      } = payload;

      const cId = showAllOrder ? null : corpId;

      const updatedFilters = smacOrderFilters.map((f) => {
        const findUpdated = filters.find((filter) => filter.key === f.key);
        if (findUpdated) {
          return findUpdated;
        }
        return f;
      });

    const queryOrderFilter = makeQuery(updatedFilters, cId, undefined, isOpen);

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'smacOrderFilters',
        value: structuredClone(updatedFilters),
      });

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'loading',
        value: true,
      });

      const { data: cOrders } = await apiClient({
        method: 'POST',
        url: 'customer/orders/query',
        data: queryOrderFilter,
      });

      commit({
        type: ORDER_CHANGE_VALUES,
        changes: [{
          field: 'customerOrders',
          value: cOrders,
        }, {
          field: 'loading',
          value: false,
        }],
      });
    } catch (err) {
      const {
        smacOrderFilters,
      } = initialState();

      // Apply previous filters
      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'smacOrderFilters',
        value: smacOrderFilters,
      });
      console.error('Failed to apply filters', err);
    }
  },
  async filterOrdersPartner({ commit, state, rootState }, payload) {
    try {
      const {
        smacOrderFilters,
        isPilot,
        isOpen,
      } = state;

      const {
        filters,
        showAllOrder,
      } = payload;

      const {
        admin: {
          adminFilter: {
            corpId,
          },
        },
      } = rootState;

      const cId = showAllOrder ? null : corpId;
      const updatedFilters = smacOrderFilters.map((f) => {
        const findUpdated = filters.find((filter) => filter.key === f.key);
        if (findUpdated) {
          return findUpdated;
        }
        return f;
      });

      const queryOrderFilter = makeQuery(updatedFilters, cId, isPilot, isOpen);

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'smacOrderFilters',
        value: structuredClone(updatedFilters),
      });

      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'loading',
        value: true,
      });
      const { data: pOrders } = await apiClient({
        method: 'POST',
        url: 'partner/orders/query',
        data: queryOrderFilter,
      });

      commit({
        type: ORDER_CHANGE_VALUES,
        changes: [{
          field: 'partnerOrders',
          value: pOrders,
        }, {
          field: 'loading',
          value: false,
        }],
      });
    } catch (err) {
      const {
        smacOrderFilters,
      } = initialState();

      // Apply previous filters
      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'smacOrderFilters',
        value: smacOrderFilters,
      });
      console.error('Failed to apply filters', err);
    }
  },
  async getAllPartnerOrders({ commit }) {
    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });

    const { data: pOrders } = await apiClient({
      method: 'GET',
      url: '/partner/orders/all/v2',
    });

    const partnerOrders = [];
    pOrders.forEach((o, index) => {
      const name = `${o.corporation.firstName} ${o.corporation.lastName}`;
      const nCorporation = {
        ...o.corporation,
        name,
      };
      let total = 0;
      let count = 0;
      let openCounter = 0;
      let holdCounter = 0;
      let error = false;
      let shipAddress = null;
      let status = '';
      if (o.orderLines && o.orderLines.length > 0) {
        const {
          shippingAddress: sA,
          deliveryDate,
          shipDate,
        } = o.orderLines[0];
        if (deliveryDate) {
          o.deliveryDate = moment(deliveryDate).format('M-DD-YY');
        }
        if (shipDate) {
          o.shipDate = moment(shipDate).format('M-DD-YY');
        }
        if (o.orderLines[0].shippingAddress && o.orderLines[0].shippingAddress) {
          if (o.orderLines[0].shippingAddress.firstName === null
            && o.orderLines[0].shippingAddress.lastName === null) {
            o.name = '--';
          } else {
            o.name = `${o.orderLines[0].shippingAddress.firstName} ${o.orderLines[0].shippingAddress.lastName}`;
          }
        } else {
          o.name = '--';
        }
        if (sA) {
          if (sA.address1) {
            shipAddress = `${sA.address1} ${sA.city}, ${sA.state} ${sA.zip}`;
          } else {
            shipAddress = 'Hand delivered';
          }
          o.orderLines.forEach((oL) => {
            if (oL.status !== 'Ignore' && !oL.sku.includes('SHIPPING') && !oL.sku.includes('SMAC10PM')) {
              total += 1;
            }
            if (oL.status === 'Error') {
              error = true;
            } else if (oL.status === 'Shipped' || oL.status === 'Delivered' || oL.status === 'Returned') {
              count += 1;
            } else if (oL.status === 'Open') {
              openCounter += 1;
            } else if (oL.status === 'Waiting for review') {
              holdCounter += 1;
            }
          });
        }

        if (error) {
          status = 'Error';
        } else if (openCounter === total) {
          status = 'No items shipped';
        } else if (holdCounter === total) {
          status = 'Waiting for review';
        } else if (count === 0) {
          status = 'Pending fulfillment';
        } else if (count < total) {
          status = 'Partially shipped';
        } else if (count === total) {
          status = 'All items shipped';
        }

        partnerOrders.push({
          ...o,
          status,
          shipAddress,
          corporation: nCorporation,
          expanded: false,
          selected: false,
          index,
        });
      }
    });

    commit({
      type: ORDER_CHANGE_VALUES,
      changes: [{
        field: 'partnerOrders',
        value: partnerOrders,
      }, {
        field: 'loading',
        value: false,
      },
      ],
    });
  },
  async getAllCustomerOrders({ commit, state }, payload) {
    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'loading',
      value: true,
    });

    const {
      smacOrderFilters,
      isOpen,
    } = state;
    const {
      filters,
    } = payload;

    const updatedFilters = smacOrderFilters.map((f) => {
      const findUpdated = filters.find((filter) => filter.key === f.key);
      if (findUpdated) {
        return findUpdated;
      }
      return f;
    });
    const queryOrderFilter = makeQuery(updatedFilters, undefined, undefined, isOpen);
    const { data: cOrders } = await apiClient({
      method: 'POST',
      url: 'customer/orders/query',
      data: queryOrderFilter,
    });

    commit({
      type: ORDER_CHANGE_VALUES,
      changes: [{
        field: 'customerOrders',
        value: cOrders,
      }, {
        field: 'loading',
        value: false,
      },
      ],
    });
  },
  async getPlatformUsers({ commit }) {
    const { data } = await apiClient({
      method: 'GET',
      url: '/admins/all/1',
    });
    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'platformUsers',
      value: data,
    });
  },
  async completeCustomerOrder({ commit, state, getters }, vendor) {
    const {
      taxTotal,
      netTotal,
    } = getters;
    const {
      newOrder: {
        customer,
        billingAddress,
        shippingAddress,
        orderItems,
        tax,
        chargeMember,
        replacement,
      },
      requestorId,
    } = state;

    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'processingOrder',
      value: true,
    });
    const orderLine = [];
    orderItems.forEach((item) => {
      const {
        price,
        productId,
        productName,
        productSku,
        productType,
        quantity,
        stripePriceId,
        filterHeight,
        filterWidth,
        brand,
        thickness,
        merv,
        discount,
        vendorSku,
        vendor: productVendor,
        filterCatalogId,
      } = item;
      let product = {
        customerId: customer.id,
        lineNumber: productId,
        sku: productSku,
        itemName: productName,
        quantity,
        price: chargeMember ? price : 0,
        total: chargeMember ? price * quantity : 0,
        type: productType,
        status: 'Open',
        stripePriceId,
        vendorSku,
        vendor: vendor ?? productVendor,
      };
      if (productType === 'Filter') {
        product = {
          ...product,
          filterCatalogId,
          width: filterWidth,
          height: filterHeight,
          thickness,
          brand,
          merv,
        };
      }
      if (discount) {
        let discountTotal = 0;
        if (discount.discountPercent) {
          discountTotal = product.total * (discount.discountPercent / 100);
        } else if (discount.discountAmount) {
          discountTotal = discount.discountAmount;
        }
        product.discountTotal = discountTotal;
        product.discountCode = discount.discountCode;
        product.discounts = [discount];
        product.total -= discountTotal;
      }
      orderLine.push(product);
    });
    const newOrder = {
      customerId: customer.customerId,
      orderTotal: netTotal,
      tax: taxTotal,
      replacement,
      requestorId,
    };
    const {
      customerId,
      ...customerInfo
    } = customer;

    const custInfo = {
      id: customerId,
      ...customerInfo,
    };

    try {
      const { data } = await apiClient({
        method: 'POST',
        url: '/checkout/chargebee/noc/order',
        data: {
          customer: custInfo,
          order: newOrder,
          orderLine,
          subscription: [],
          taxId: null,
          taxRate: tax ? tax.percentage : 0,
          shippingAddress,
          billingAddress,
          subtotal: netTotal,
          chargeMember,
        },
      });
      commit({
        type: ORDER_CHECKOUT_COMPLETE,
      });
      return data;
    } catch (err) {
      console.error(err);
      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'processingOrder',
        value: false,
      });
      throw err;
    }
  },
  async clearMemberOrdersFilters({ commit }) {
    const {
      smacOrderFilters,
    } = initialState();

    // Apply previous filters
    commit({
      type: ORDER_CHANGE_VALUE,
      field: 'smacOrderFilters',
      value: smacOrderFilters,
    });
  },
  async getFilterVendorCatalogs({ commit }, request) {
    try {
      const { data } = await apiClient({
        method: 'POST',
        url: '/vendor/catalog/query',
        data: {
          catalogIds: [request.catalogId],
          customerId: request.customerId,
        },
      });
      commit({
        type: ORDER_CHANGE_VALUES,
        changes: [{
          field: 'filterVendorCatalogs',
          value: data,
        },
        {
          field: 'loadingOrders',
          value: false,
        },
        ],
      });
    } catch (err) {
      console.error('Error querying vendor catalog', err);
    } finally {
      commit({
        type: ORDER_CHANGE_VALUE,
        field: 'loadingOrders',
        value: false,
      });
    }
  },
  async getTaxRate({ dispatch, state }) {
    const {
      newOrder,
    } = state;
    const orderLine = [];
    if (newOrder.orderItems) {
      newOrder.orderItems.forEach((item) => {
        const {
          basePrice,
          price,
          productId,
          productName,
          productSku,
          productType,
          quantity,
          stripePriceId,
          filterHeight,
          filterWidth,
          thickness,
          merv,
        } = item;
        if (productType === 'Filter') {
          orderLine.push({
            lineNumber: productId,
            sku: productSku,
            itemName: productName,
            quantity,
            price: basePrice,
            total: price,
            type: productType,
            status: 'Waiting for review',
            stripePriceId,
            width: filterWidth,
            height: filterHeight,
            thickness,
            merv,
          });
        } else {
          orderLine.push({
            lineNumber: productId,
            sku: productSku,
            itemName: productName,
            quantity,
            price: basePrice,
            total: price,
            type: productType,
            status: 'Open',
            stripePriceId,
          });
        }
      });
    }
    const { data } = await apiClient({
      method: 'POST',
      url: '/chargebee/estimate/invoice',
      data: {
        billingAddress: newOrder.billingAddress,
        orderLine,
      },
    });
    const nOrder = {
      ...newOrder,
    };
    if (data.total - data.sub_total !== 0) {
      nOrder.tax = {
        jurisdiction: newOrder.billingAddress.state,
        percentage: data.line_items[0].tax_rate,
      };
      dispatch('changeOrderValue', {
        field: 'newOrder',
        value: nOrder,
      });
    }
  },
};

export default actions;
